// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8727ae6fdfebfc90696416cc8efe1538149be089.chunk.js";
};